// Privacy.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./Terms.css";

function Privacy() {
  return (
    <div className="terms-page">
      <header className="app-bar" role="banner">
        <div className="app-bar__inner">
          <Link to="/" className="brand-link" aria-label="메인으로 돌아가기">
            TooLoves
          </Link>
        </div>
      </header>

      <main id="content" role="main" className="container" aria-labelledby="privacy-title">
        <article className="generator-card terms-card" aria-labelledby="privacy-title">
          <header className="terms-header">
            <h1 id="privacy-title" className="card-title">TooLoves.net 개인정보 처리방침</h1>
            <p className="card-subtitle terms-updated">
              마지막 업데이트:
              <time dateTime="2025-10-22"> 2025년 10월 22일(KST)</time>
            </p>
          </header>

          <section className="terms-section">
            <p>
              본 개인정보 처리방침("방침")은 TooLoves.net("사이트") 운영자가 이용자의 개인정보를 어떻게 처리하는지 안내합니다.
              사이트를 이용함으로써 이용자는 본 방침에 동의한 것으로 간주됩니다.
            </p>
          </section>

          <section className="terms-section" id="info-collection">
            <h2 className="section-title">1. 수집하는 개인정보</h2>
            <p>
              본 사이트는 이용자 개인을 식별할 수 있는 정보(예: 이름, 이메일, IP 주소 등)를 직접 수집하지 않습니다.
              QR 코드 생성, 이미지 워터마크, EXIF 추출 등 모든 기능은 이용자의 기기에서 처리되며, 이미지나 데이터는 서버에 업로드 또는 전송되지 않습니다.
            </p>
            <p>
              단, 본 사이트는 서비스 품질 향상 및 이용 통계 분석을 위해{" "}
              <strong>Google Analytics(GA4)</strong>를 사용합니다. Google은 쿠키(Cookie) 등을 활용하여 
              이용자의 접속 기기 정보, 방문한 페이지, 체류 시간, 클릭 이벤트, 브라우저 종류, 접속 지역(도시 단위 위치 정보) 등의
              <strong> 비식별 데이터를 자동으로 수집</strong>할 수 있습니다. 
              이 데이터는 개인을 식별할 수 없으며, 사이트 운영 및 서비스 개선 목적에 한하여 사용됩니다.
            </p>
          </section>

          <section className="terms-section" id="use-of-info">
            <h2 className="section-title">2. 개인정보 이용 목적</h2>
            <p>
              수집되는 정보는 사이트의 트래픽 분석, 오류 진단, 서비스 개선 등 통계적 목적으로만 이용됩니다.
              본 사이트는 Google Analytics(GA4), Netlify, 및 Google AdSense의 정책을 따릅니다.
            </p>
          </section>

          <section className="terms-section" id="data-sharing">
            <h2 className="section-title">3. 개인정보 제공 및 공유</h2>
            <p>
              본 사이트는 개인정보를 직접 수집·저장하지 않습니다.
              다만, 서비스 제공에 사용되는 Netlify, Google AdSense, 및 Google Analytics에 의해 
              자동 수집이 발생할 수 있습니다. 이 과정에서 수집되는 정보는 각 서비스 제공자의 개인정보처리방침에 따라 관리됩니다.
            </p>
          </section>

          <section className="terms-section" id="data-security">
            <h2 className="section-title">4. 개인정보 보호</h2>
            <p>
              본 사이트는 자체적으로 개인정보를 저장하지 않으며, 사이트 운영에 필요한 인프라는{" "}
              <strong>Netlify</strong>의 보안 정책을 따릅니다. 또한 광고 및 통계 분석에는{" "}
              <strong>Google AdSense</strong>와 <strong>Google Analytics</strong>의 보안 체계가 적용됩니다.
            </p>
            <p>
              이용자는 브라우저 설정을 통해 쿠키 사용을 거부하거나,{" "}
              <a
                href="https://tools.google.com/dlpage/gaoptout"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Analytics 차단 브라우저 추가 기능
              </a>
              을 설치하여 데이터 수집을 거부할 수 있습니다.
            </p>
          </section>

          <section className="terms-section" id="policy-changes">
            <h2 className="section-title">5. 방침 변경</h2>
            <p>
              운영자는 필요에 따라 개인정보 처리방침을 변경할 수 있으며, 변경 시 사이트 공지 또는 본 페이지를 통해 안내됩니다.
            </p>
            <p>
              이용자가 변경 후에도 서비스를 계속 이용하면 변경된 방침에 동의한 것으로 간주됩니다.
            </p>
          </section>

          <section className="terms-section" id="contact">
            <h2 className="section-title">6. 문의</h2>
            <p>
              서비스 관련 문의는{" "}
              <a
                href="mailto:helptooloves@gmail.com"
                className="mailto-link"
                aria-label="helptooloves@gmail.com으로 이메일 보내기"
              >
                helptooloves@gmail.com
              </a>
              으로 문의 바랍니다.
            </p>
          </section>

          <div className="terms-actions">
            <Link to="/" className="btn" aria-label="메인 페이지로 돌아가기">
              메인으로 돌아가기
            </Link>
          </div>
        </article>
      </main>

      <footer className="footer" role="contentinfo">
        © 2025 TooLoves. All rights reserved.
      </footer>
    </div>
  );
}

export default Privacy;
